import SectionContainer from '@/components/layout/SectionContainer.vue';

import { FORM_LAYOUT } from '@/utils/form/formLayout';
import type { FormConfig } from '@/utils/form';
import {
  addDriver,
  alterAeltesterFahrer,
  alterJuengsterFahrer,
  altersbeschraenkung,
  fahrerkreisTyp,
  isVnFahrer,
  isVnHauptnutzer,
} from '@/features/Sparten/shared/fieldConfigs/kfz/input/fahrerkreisFieldConfig';
import { SECTION } from '@/components/layout/types';

export const fahrerkreisSection: FormConfig = {
  formName: 'KfzFahrerkreis',
  gridClasses: 'grid',
  fieldConfigs: [
    {
      component: SectionContainer,
      childWrapperClasses: FORM_LAYOUT.GRID_4_COLS,
      inputAttrs: {
        name: SECTION.KFZ_INPUT_FAHRERKREIS,
        inline: true,
      },
      fieldConfigs: [fahrerkreisTyp, isVnFahrer, isVnHauptnutzer],
    },
    {
      component: SectionContainer,
      childWrapperClasses: FORM_LAYOUT.GRID_4_COLS,
      inputAttrs: {
        name: SECTION.KFZ_FAHRERKREIS_ALTER,
        inline: true,
      },
      fieldConfigs: [
        altersbeschraenkung,
        alterJuengsterFahrer,
        alterAeltesterFahrer,
      ],
    },
    {
      component: SectionContainer,
      childWrapperClasses: FORM_LAYOUT.GRID_4_COLS,
      inputAttrs: {
        name: SECTION.KFZ_FAHRER_ADD,
        inline: true,
      },
      fieldConfigs: [addDriver],
    },
  ],
};
